import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AppBar, Button, Container, makeStyles, Toolbar } from '@material-ui/core'

import Location from '../../../components/Cards/Household/Location'
import Notes from '../../../components/Cards/Household/Notes'
import Other from '../../../components/Cards/Household/Other'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import Alert from '../../../components/Misc/Alert'
import { updateHousehold } from '../../../actions/households/households.actions'
import { useHistory } from 'react-router-dom'
import { isEqual, cloneDeep } from 'lodash'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '20px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important',
		zIndex: 1201
	}
}))

const Household = () => {
	const classes = useStyles()
	const history = useHistory()
	const dispatch = useDispatch()
	const currentHousehold = useSelector((state) => state.specific.households.selected)
	const loading = useSelector((state) => state.specific.households.loading)
	const error = useSelector((state) => state.specific.households.error)

	const [household, setHousehold] = useState(null)
	const [current, setCurrent] = useState(null)
	const [isHouseholdValid, setIsHouseholdValid] = useState(false)
	const [alert, setAlert] = useState(null)
	const [isSaveShown, setIsSaveShown] = useState(false)

	useEffect(() => {
		if (currentHousehold) {
			setHousehold(cloneDeep({ ...currentHousehold, account_guardians: currentHousehold.accounts }))
			setCurrent(cloneDeep({ ...currentHousehold, account_guardians: currentHousehold.accounts }))
		}
	}, [currentHousehold])

	useEffect(() => {
		if (current && household) {
			let equal = !isEqual(current, household)
			setIsSaveShown(equal)
		}
	}, [current, household])

	useEffect(() => {
		if (error) {
			showError(error)
		}
	}, [error])

	const updateGuardian = (pet_guardians) => {
		let changes = {}

		let current_guardians = current?.pet_guardians || []

		if (current_guardians && !_.isEqual(current_guardians, pet_guardians)) changes.pet_guardians = pet_guardians
		dispatch(updateHousehold(current._id, changes)).then(() => {
			if (!error) {
				showSuccess(`Household saved!`)
			}
		})
	}

	const saveHousehold = () => {
		let {
			notes,
			market,
			apartment_id,
			apartment,
			building_type,
			private_admin_notes,
			contact,
			consultation_status,
			authorized_pickups,
			dog_walking
		} = household

		let changes = {
			notes: notes || '',
			private_admin_notes: private_admin_notes || '',
			contact,
			building_type,
			consultation_status,
			authorized_pickups,
			dog_walking
		}
	

		if (current.account_guardians && !_.isEqual(current.account_guardians, household.account_guardians)) changes.account_guardians = household.account_guardians

		if (current.pet_guardians && !_.isEqual(current.pet_guardians, household.pet_guardians)) changes.pet_guardians = household.pet_guardians

		if ((!current.market && market) || (current.market && market._id !== current.market._id)) {
			changes.market_id = market._id
			if (household.default_facility_id) {
				changes.default_facility_id = household.default_facility_id
			}
		}

		if (String(current.default_facility_id || '') !== String(household.default_facility_id || '')) {
			changes.default_facility_id = household.default_facility_id || null
		}

		if ((!current.apartment && apartment) || (current.apartment && apartment._id !== current.apartment._id)) {
			changes.apartment_id = apartment._id
		}

		let values = ['Apartment', 'Condo', 'apartment', 'condo']

		if (building_type !== current.building_type) {
			if (!values.includes(building_type) && building_type !== 'Apartment / Condo' && apartment_id) {
				changes.apartment_id = null
			}
		}

		if (
			changes.contact &&
			changes.contact.address &&
			changes.contact.address.state &&
			changes.contact.address.state.id
		) {
			changes.contact.address.state = changes.contact.address.state.id
		}

		dispatch(updateHousehold(current._id, changes)).then(() => {
			if (!error) {
				showSuccess(`Household saved!`)
			}
		})
	}

	const showSuccess = (message) => {
		setAlert({
			anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
			severity: 'success',
			message: message
		})
	}

	const showError = (error) => {
		setAlert({
			anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
			severity: 'error',
			message: error
		})
	}

	const goToClient = () => {
		if (current) {
			history.push(`/clients/${current._id}/appointments`)
		}
	}

	return (
		<Container className={classes.root} maxWidth="md">
			{household ? (
				<div>
					<Location household={household} setHousehold={setHousehold} />
					<Notes household={household} setHousehold={setHousehold} />
					<Other household={household} setHousehold={setHousehold} updateGuardian={updateGuardian}/>
					{isSaveShown ? (
						<AppBar position="fixed" color="primary" className={classes.appBar}>
							<Toolbar>
								<Container maxWidth="md">
									<Button
										variant="contained"
										color="secondary"
										disabled={loading}
										style={{ marginRight: '8px' }}
										onClick={() => saveHousehold()}>
										Save Changes
									</Button>
									<Button variant="outlined" color="secondary" onClick={goToClient}>
										Cancel
									</Button>
								</Container>
							</Toolbar>
						</AppBar>
					) : null}
					<Alert {...alert} />
				</div>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</Container>
	)
}

export default Household
